module.exports = __webpack_public_path__ + "media/images/flags/32/Tunisia-e30fd55b59f74f49467497ca34c9a930.png";